import { clarity } from 'react-microsoft-clarity';

export const initClarity = () => {

  clarity.init("rfqa8v8r20");
  clarity.consent();
  clarity.start();

};